export const electroMagnetoShield = {
    name: "Electro Magneto shield",
    image: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQQKjiBZ3LVHcHgLmuvc8QyCn1WpNMPQxxcsvwMGohoDK/shields/Electro%20Magneto%20shield.gif",

    sprite_photo: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmbLCWNLsrkiR4FWxg2mMvkTkMm3rbVMJxfLmCmXYqx6di/shields/sprite%20photo/Electro%20Magneto%20shield.png",
    bar_photo: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmbLCWNLsrkiR4FWxg2mMvkTkMm3rbVMJxfLmCmXYqx6di/shields/Bar%20photo/Electro%20Magneto%20shield.png",
    level: "1",
    sound: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmbLCWNLsrkiR4FWxg2mMvkTkMm3rbVMJxfLmCmXYqx6di/shields/sound/Electro%20Magneto%20shield.wav",
    class: "Shield",
    uri: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQyYC6NJTmqN3WbuxvHMqLMMEYsuHb6QP58Cfop6QCBwm/shields/Electro%20Magneto%20shield.json",
};

export const plasmaMembraneShield = {
    name: "Plasma Membrane shield",
    image: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmWoGvPywR26ZpRsfzznr3F8re7MbjLMXQtWm1sXRtaVTf/Plasma%20Membrane%20shield.gif",

    sprite_photo: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmbLCWNLsrkiR4FWxg2mMvkTkMm3rbVMJxfLmCmXYqx6di/shields/sprite%20photo/Plasma%20Membrane%20shield.png",
    bar_photo: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmbLCWNLsrkiR4FWxg2mMvkTkMm3rbVMJxfLmCmXYqx6di/shields/Bar%20photo/Plasma%20Membrane%20shield.png",
    level: "1",
    sound: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmbLCWNLsrkiR4FWxg2mMvkTkMm3rbVMJxfLmCmXYqx6di/shields/sound/Plasma%20Membrane%20shield.wav",
    class: "Shield",
    uri: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQyYC6NJTmqN3WbuxvHMqLMMEYsuHb6QP58Cfop6QCBwm/shields/Plasma%20Membrane%20shield.json",
};

export const hydraShield = {
    name: "Hydra shield",
    image: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmWoGvPywR26ZpRsfzznr3F8re7MbjLMXQtWm1sXRtaVTf/Hydra%20shield.gif",

    sprite_photo: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmbLCWNLsrkiR4FWxg2mMvkTkMm3rbVMJxfLmCmXYqx6di/shields/sprite%20photo/Hydra%20shield.png",
    bar_photo: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmbLCWNLsrkiR4FWxg2mMvkTkMm3rbVMJxfLmCmXYqx6di/shields/Bar%20photo/Hydra%20shield.png",
    level: "1",
    sound: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmbLCWNLsrkiR4FWxg2mMvkTkMm3rbVMJxfLmCmXYqx6di/shields/sound/Hydra%20shield.wav",
    class: "Shield",
    uri: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQyYC6NJTmqN3WbuxvHMqLMMEYsuHb6QP58Cfop6QCBwm/shields/Hydra%20shield.json",
};

export const shields = {
    electroMagnetoShield,
    plasmaMembraneShield,
    hydraShield,
};

export const SFM_SHIELD_CONTRACT_ADDRESS =
    "0xA25c570611EAE4aa8D8C616Ed481bb0c234d577c";

export const SFM_SHIELD_CONTRACT_ABI = [
  {
    "inputs": [],
    "stateMutability": "nonpayable",
    "type": "constructor"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "owner",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "approved",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "Approval",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "owner",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "operator",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "bool",
        "name": "approved",
        "type": "bool"
      }
    ],
    "name": "ApprovalForAll",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "_fromTokenId",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "_toTokenId",
        "type": "uint256"
      }
    ],
    "name": "BatchMetadataUpdate",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "_tokenId",
        "type": "uint256"
      }
    ],
    "name": "MetadataUpdate",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "previousOwner",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "newOwner",
        "type": "address"
      }
    ],
    "name": "OwnershipTransferred",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "Transfer",
    "type": "event"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "approve",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "owner",
        "type": "address"
      }
    ],
    "name": "balanceOf",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "getApproved",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_tokenId",
        "type": "uint256"
      }
    ],
    "name": "getMetadata",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "tokenId",
            "type": "uint256"
          },
          {
            "internalType": "string",
            "name": "name",
            "type": "string"
          },
          {
            "internalType": "string",
            "name": "image",
            "type": "string"
          },
          {
            "internalType": "string",
            "name": "sprite_photo",
            "type": "string"
          },
          {
            "internalType": "string",
            "name": "bar_photo",
            "type": "string"
          },
          {
            "internalType": "string",
            "name": "level",
            "type": "string"
          },
          {
            "internalType": "string",
            "name": "sound",
            "type": "string"
          },
          {
            "internalType": "string",
            "name": "class",
            "type": "string"
          }
        ],
        "internalType": "struct SafemoonShield.Token",
        "name": "",
        "type": "tuple"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "owner",
        "type": "address"
      }
    ],
    "name": "getNftsbyOwner",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "tokenId",
            "type": "uint256"
          },
          {
            "internalType": "string",
            "name": "name",
            "type": "string"
          },
          {
            "internalType": "string",
            "name": "image",
            "type": "string"
          },
          {
            "internalType": "string",
            "name": "sprite_photo",
            "type": "string"
          },
          {
            "internalType": "string",
            "name": "bar_photo",
            "type": "string"
          },
          {
            "internalType": "string",
            "name": "level",
            "type": "string"
          },
          {
            "internalType": "string",
            "name": "sound",
            "type": "string"
          },
          {
            "internalType": "string",
            "name": "class",
            "type": "string"
          }
        ],
        "internalType": "struct SafemoonShield.Token[]",
        "name": "",
        "type": "tuple[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "owner",
        "type": "address"
      }
    ],
    "name": "getTokenIdsByOwner",
    "outputs": [
      {
        "internalType": "uint256[]",
        "name": "",
        "type": "uint256[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "owner",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "operator",
        "type": "address"
      }
    ],
    "name": "isApprovedForAll",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "name",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "owner",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "ownerOf",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "renounceOwnership",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "internalType": "string",
        "name": "uri",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "_name",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "_image",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "_sprite_photo",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "_bar_photo",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "_level",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "_sound",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "_class",
        "type": "string"
      }
    ],
    "name": "safeMint",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "safeTransferFrom",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      },
      {
        "internalType": "bytes",
        "name": "data",
        "type": "bytes"
      }
    ],
    "name": "safeTransferFrom",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "operator",
        "type": "address"
      },
      {
        "internalType": "bool",
        "name": "approved",
        "type": "bool"
      }
    ],
    "name": "setApprovalForAll",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "bytes4",
        "name": "interfaceId",
        "type": "bytes4"
      }
    ],
    "name": "supportsInterface",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "symbol",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "name": "tokenMetadata",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      },
      {
        "internalType": "string",
        "name": "name",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "image",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "sprite_photo",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "bar_photo",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "level",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "sound",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "class",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "tokenURI",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "transferFrom",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "newOwner",
        "type": "address"
      }
    ],
    "name": "transferOwnership",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  }
];
